import { createSlice } from "@reduxjs/toolkit";

const productListFilterSlice = createSlice({
  name: "productListFilter",
  initialState: {
    category: null,
    inventory_id: null,
    status: null,
    search: null,
    cursor: 0,         // NEW
    pagination: 1,     // NEW (items per page)
  },
  reducers: {
    setProductListFilter: (state, action) => {
      state.category = action.payload.category ?? state.category;
      state.inventory_id = action.payload.inventory_id ?? state.inventory_id;
      state.status = action.payload.status ?? state.status;
      state.search = action.payload.search ?? state.search;
      state.cursor = action.payload.cursor ?? state.cursor;
      state.pagination = action.payload.pagination ?? state.pagination;
    },

    clearProductListFilters: (state) => {
      state.category = null;
      state.inventory_id = null;
      state.status = null;
      state.search = null;
      state.cursor = 0;
      state.pagination = 1;
    },
  },
});

export const { setProductListFilter, clearProductListFilters } =
  productListFilterSlice.actions;

export const selectProductListState = (state) => state.productListFilter;

export default productListFilterSlice.reducer;
